type TranslationKeys = {
    UPDATED_AT: string;
    GREETING_TITLE: string;
    GREETING_MESSAGE: string;
    INPUT_PLACEHOLDER: string;
    ERROR_PREFIX: string;
    SOURCES_PANEL_TITLE: string;
    SOURCES_PAGES_LABEL: string;
    ALL_SOURCES_PANEL_TITLE: string;
    NO_SOURCES_MESSAGE: string;
    SESSION_ID_LABEL: string;
    EXTERNAL_LINK_LABEL: string;
    TOOLTIP_COPY: string;
    TOOLTIP_SOURCES: string;
    TOOLTIP_THUMBS_UP: string;
    TOOLTIP_THUMBS_DOWN: string;
    TOOLTIP_ALL_SOURCES: string;
};

export type Translation = { [K in keyof TranslationKeys]: string };
export type TranslationKey = keyof TranslationKeys;

const en: Translation = {
    UPDATED_AT: "Updated at",
    GREETING_TITLE: "Hi!",
    GREETING_MESSAGE: "How can I help you?",
    INPUT_PLACEHOLDER: "Write a message...",
    ERROR_PREFIX: "Error",
    SOURCES_PANEL_TITLE: "Sources",
    SOURCES_PAGES_LABEL: "Pages",
    ALL_SOURCES_PANEL_TITLE: "All Sources",
    NO_SOURCES_MESSAGE: "No sources available",
    SESSION_ID_LABEL: "Id",
    EXTERNAL_LINK_LABEL: "External link",
    TOOLTIP_COPY: "Copy message",
    TOOLTIP_SOURCES: "View sources",
    TOOLTIP_THUMBS_UP: "Good response",
    TOOLTIP_THUMBS_DOWN: "Bad response",
    TOOLTIP_ALL_SOURCES: "View all sources",
};

const sv: Translation = {
    UPDATED_AT: "Uppdaterad",
    GREETING_TITLE: "Hej!",
    GREETING_MESSAGE: "Hur kan jag hjälpa dig?",
    INPUT_PLACEHOLDER: "Skriv ett meddelande...",
    ERROR_PREFIX: "Fel",
    SOURCES_PANEL_TITLE: "Källor",
    SOURCES_PAGES_LABEL: "Sidor",
    ALL_SOURCES_PANEL_TITLE: "Alla källor",
    NO_SOURCES_MESSAGE: "Inga källor tillgängliga",
    SESSION_ID_LABEL: "Id",
    EXTERNAL_LINK_LABEL: "Extern länk",
    TOOLTIP_COPY: "Kopiera meddelande",
    TOOLTIP_SOURCES: "Visa källor",
    TOOLTIP_THUMBS_UP: "Bra svar",
    TOOLTIP_THUMBS_DOWN: "Dåligt svar",
    TOOLTIP_ALL_SOURCES: "Visa alla källor",
};

export const Translations = {
    en,
    sv,
};

export type Locale = keyof typeof Translations;
